import $ from 'jquery';

$.fn.vote = function (options) {

    // This is the easiest way to have default options.
    const settings = $.extend({}, options);

    return this.each(function () {

        const parent = $(this);

        const vote_url = $(this).attr('data-action');

        const vote_messages = {
            'select_answer': $(this).attr('data-select-error')
        };

        parent.find(".voting--radio").change(function () {

            const answerId = $(this).attr('value');

            $.ajax({
                type: 'get',
                'url': vote_url + answerId,
                success: function (result) {

                    let messageText = '';
                    let messageClass = "";
                    let messageContainer = parent.find('.voting--message');
                    if (!messageContainer.length) {
                        messageContainer = $('<div class="voting--message "></div>');
                    }

                    parent.append(messageContainer);

                    $.each(result.messages, function (index, message) {
                        messageText = messageText + message + '<br/>';
                    });

                    const messageClasses = {
                        error: 'voting--message__error',
                        success: 'voting--message__success'
                    }

                    if (result.status == 'failed') {
                        messageClass = messageClasses.error;
                    } else if (result.status == 'success') {
                        messageClass = messageClasses.success;
                        if (result.answers) {
                            $.each(result.answers, function (answer_id, percent) {
                                let percentElement = document.getElementById("voting--option-percent-" + answer_id);
                                if (percent == null) {
                                    percentElement.innerText = "0%";
                                } else {
                                    percentElement.innerText = percent + "%";
                                }
                                let bar = document.getElementById("voting-bar-" + answer_id);
                                $(bar).css("width", percent + "%");
                            });
                        }
                    }

                    Object.keys(messageClasses).forEach((c) => {
                        messageContainer.removeClass(messageClasses[c]);
                    });
                    messageContainer.addClass(messageClass)
                    messageContainer.hide().html(messageText);
                    messageContainer.stop().fadeIn(500);
                    setTimeout(function () {
                        // messageContainer.stop().fadeOut(500);
                    }, 1500);

                }

            });
        });

    });

};


export default class Vote {


    constructor(selector, options = {}) {

        $(selector).vote(options)
    }


    // $(document).ready(function () {
    // 	$('.icon-cancel').click(function () {
    // 		$('.popup').stop().fadeOut();
    // 		setTimeout(function () {
    // 			$('.popup').remove();
    // 		}, 1500);
    // 	});
    // });

}



// WEBPACK FOOTER //
// ./src/scripts/vote.js